import React, { forwardRef } from 'react';
import '@styled-system/css';
import merge from 'deepmerge';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import '@primer/behaviors/utils';
import '@primer/behaviors';
import { useRefObjectAsForwardedRef } from '../hooks/useRefObjectAsForwardedRef.js';
import Heading$1 from '../Heading/Heading.js';
import { ListContext } from './shared.js';
import VisuallyHidden from '../_VisuallyHidden.js';
import { ActionListContainerContext } from './ActionListContainerContext.js';
import { invariant } from '../utils/invariant.js';
import { clsx } from 'clsx';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import classes from './Heading.module.css.js';
import { actionListCssModulesFlag } from './featureflag.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Heading = /*#__PURE__*/forwardRef(({
  as,
  size,
  children,
  sx = defaultSxProp,
  visuallyHidden = false,
  className,
  ...props
}, forwardedRef) => {
  var _props$id, _props$id2, _props$id3;
  const innerRef = React.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const enabled = useFeatureFlag(actionListCssModulesFlag);
  const {
    headingId: headingId,
    variant: listVariant
  } = React.useContext(ListContext);
  const {
    container
  } = React.useContext(ActionListContainerContext);

  // Semantic <menu>s don't have a place for headers within them, they should be aria-labelledby the menu button's name.
  !(container !== 'ActionMenu') ? process.env.NODE_ENV !== "production" ? invariant(false, `ActionList.Heading shouldn't be used within an ActionMenu container. Menus are labelled by the menu button's name.`) : invariant(false) : undefined;
  const styles = {
    marginBottom: 2,
    marginX: listVariant === 'full' ? 2 : 3
  };
  return /*#__PURE__*/React.createElement(VisuallyHidden, {
    isVisible: !visuallyHidden
  }, enabled ? sx !== defaultSxProp ? /*#__PURE__*/React.createElement(Heading$1, _extends({
    as: as,
    variant: size,
    ref: innerRef
    // use custom id if it is provided. Otherwise, use the id from the context
    ,
    id: (_props$id = props.id) !== null && _props$id !== undefined ? _props$id : headingId,
    className: clsx(className, classes.ActionListHeader),
    "data-list-variant": listVariant,
    sx: sx
  }, props), children) : /*#__PURE__*/React.createElement(Heading$1, _extends({
    as: as,
    variant: size,
    ref: innerRef
    // use custom id if it is provided. Otherwise, use the id from the context
    ,
    id: (_props$id2 = props.id) !== null && _props$id2 !== undefined ? _props$id2 : headingId,
    className: clsx(className, classes.ActionListHeader),
    "data-list-variant": listVariant
  }, props), children) : /*#__PURE__*/React.createElement(Heading$1, _extends({
    as: as,
    variant: size,
    ref: innerRef
    // use custom id if it is provided. Otherwise, use the id from the context
    ,
    id: (_props$id3 = props.id) !== null && _props$id3 !== undefined ? _props$id3 : headingId,
    sx: merge(styles, sx),
    className: className
  }, props), children));
});
Heading.displayName = 'ActionList.Heading';

export { Heading };
